import React from 'react'
import parser from 'html-react-parser'
import { Link } from 'gatsby'

export default function Donation3({ data }) {
    const { donation3ButtonText, donation3Text, donation3Title, donation3ButtonLink, donation3ButtonExternalLink } = data
    return (
        <div className='donatenow-wrap'>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-8'>
                        <div className='donatenow-content'>
                            <div className='donatenow-title'>{donation3Title && parser(donation3Title)}</div>
                            <p>{donation3Text && parser(donation3Text)}</p>
                        </div>
                    </div>
                    <div className='col-md-4 donatenow-btn-sec'>
                        {donation3ButtonExternalLink ? (
                            <a href={donation3ButtonExternalLink} className="btn blue-arrow-btn">
                                {donation3ButtonText}
                            </a>
                        ) : donation3ButtonLink && (
                            <Link
                                to={donation3ButtonLink.uri}
                                className='btn blue-arrow-btn'
                            >
                                {donation3ButtonText}
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}
